import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { VALIDATION_ERROR_MESSAGE } from '@shared/constants';

@Pipe({
  name: 'errorMessage',
  pure: true,
})
export class ErrorMessagePipe implements PipeTransform {
  protected errorsMessages = VALIDATION_ERROR_MESSAGE;

  transform(
    errors: ValidationErrors | null,
    errorMessages: ValidationErrors | null,
  ): string | null {
    if (!errors) return null;

    const messages = {
      ...this.errorsMessages,
      ...errorMessages,
    };

    for (const key in errors) {
      return messages[key]?.(errors[key]);
    }

    return null;
  }
}
